import React from "react";
import { BASE_URL ,BASE_URL_OLD} from "./../../../../../env_config"
import {OverlayTrigger,Tooltip} from "react-bootstrap";

export default function CompanyInfo({userinfo,setEdit,contactbookuserinfo,language}) {
    return (
        <>
            <div className="row">
                <div className="col-12 border-bottom d-flex justify-content-between pb-3 mb-5 mt-8">
                    <h4>{language.PROFILEVIEW_COMPANY_INFORMATION}</h4>
                    {/* <button className="btn btn-sm btn-secondary" onClick={() => setEdit(true)}>{language.PROFILE_EDIT}</button> */}
                </div>
                <div className="col-md-7 mb-4 d-md-flex justify-content-between align-items-end">
                    <div>
                        <div className="text-muted font-size-lg font-weight-bold" >{language.PROFILE_EDIT_COMPANY_NAME}</div>
                        <div className="font-size-lg font-weight-bold" >{userinfo.cname}</div>
                    </div>
                    {contactbookuserinfo.cname !== userinfo.cname?<span className="text-primary font-weight-bold">{language.PROFILE_EDITED}</span>:""}
                </div>
                <div className="col-md-7 mb-4 d-md-flex justify-content-between align-items-end">
                    <div>
                        <div className="text-muted font-size-lg font-weight-bold" >{language.PROFILE_BILLING_COMPANY_NAME}</div>
                        <div className="font-size-lg font-weight-bold" >{userinfo.company_name_official}</div>
                    </div>
                    {contactbookuserinfo.company_name_official !== userinfo.company_name_official?<span className="text-primary font-weight-bold">{language.PROFILE_EDITED}</span>:""}
                </div>
                <div className="col-md-7 mb-4 d-md-flex justify-content-between align-items-end">
                    <div>
                        <div className="text-muted font-size-lg font-weight-bold" >{language.INVOICE_DETAIL_ADDRESS}</div>
                        <div className="font-size-lg font-weight-bold" >{userinfo.address} {userinfo.secaddress?<>,{userinfo.secaddress}</>:""} {userinfo.addressline3?<>,{userinfo.addressline3}</>:""}, {userinfo.city} {userinfo.state} <br />{userinfo.country} {userinfo.com_zip}</div>
                    </div>
                    {contactbookuserinfo.address !== userinfo.address || contactbookuserinfo.secaddress !== userinfo.secaddress|| contactbookuserinfo.addressline3 !== userinfo.addressline3 || contactbookuserinfo.city !== userinfo.city || contactbookuserinfo.state !== userinfo.state || contactbookuserinfo.country !== userinfo.country || contactbookuserinfo.com_zip !== userinfo.com_zip?<span className="text-primary font-weight-bold">{language.PROFILE_EDITED}</span>:""}

                </div>
                <div className="col-md-7 mb-4 d-md-flex justify-content-between align-items-end">
                    <div>
                        <div className="text-muted font-size-lg font-weight-bold" >{language.PROFILE_EDIT_TELEPHONE}</div>
                        <div className="font-size-lg font-weight-bold" >{userinfo.mobile}</div>
                    </div>
                    {contactbookuserinfo.mobile !== userinfo.mobile?<span className="text-primary font-weight-bold">{language.PROFILE_EDITED}</span>:""}
                </div>
                <div className="col-md-7 mb-4 d-md-flex justify-content-between align-items-end">
                    <div>
                        <div className="text-muted font-size-lg font-weight-bold" >{language.PROFILE_EDIT_FAX}</div>
                        <div className="font-size-lg font-weight-bold" >{userinfo.fax}</div>
                    </div>
                    {contactbookuserinfo.fax !== userinfo.fax?<span className="text-primary font-weight-bold">{language.PROFILE_EDITED}</span>:""}

                </div>
                <div className="col-md-7 mb-4 d-md-flex justify-content-between align-items-end">
                    <div>
                        <div className="text-muted font-size-lg font-weight-bold" >{language.PROFILE_WEBSITE}</div>
                        <div className="font-size-lg font-weight-bold" >{userinfo.website}</div>
                    </div>
                    {contactbookuserinfo.website !== userinfo.website?<span className="text-primary font-weight-bold">{language.PROFILE_EDITED}</span>:""}

                </div>
                <div className="col-md-7 mb-4 d-md-flex justify-content-between align-items-end">
                    <div>
                        <div className="text-muted font-size-lg font-weight-bold" >{language.PROFILE_EDIT_INVOICE_NOTIFICATION_EMAIL}</div>
                        <div className="font-size-lg font-weight-bold" >{userinfo.invoiceemail}</div>
                    </div>
                    {contactbookuserinfo.invoiceemail !== userinfo.invoiceemail?<span className="text-primary font-weight-bold">{language.PROFILE_EDITED}</span>:""}

                </div>
                <div className="col-md-7 mb-4  d-flex justify-content-between align-items-end">
                    <div>
                        <div className="text-muted font-size-lg font-weight-bold" >{userinfo?.region === "India"?"PAN/GST Document":language.PROFILE_EDIT_COMP_REG}</div>
                        <div className="row">
                            <div className="col-md-12 d-md-flex">
                                <div className="font-size-lg font-weight-bold" >{userinfo.com_reg_no}  </div>
                                {userinfo.com_reg_doc ? 
                                    <OverlayTrigger
                                        placement="top"
                                        className="text-capitalize"
                                        overlay={<Tooltip id="tooltip">{userinfo.com_reg_doc}</Tooltip>}
                                    >
                                        <a href={process.env.REACT_APP_ENV === "production"?`https://assets.diamondsoncall.com/assets/documents/${userinfo.com_reg_doc}`:`${BASE_URL_OLD}/assets/documents/${userinfo.com_reg_doc}`} target="_blank" rel="noreferrer" className="font-weight-bold ml-md-10">{language.PROFILE_EDIT_VIEW_IMAGE}</a>
                                    </OverlayTrigger>
                                : "" }
                            </div>
                        </div>
                    </div>
                    {contactbookuserinfo.com_reg_doc !== userinfo.com_reg_doc?<span className="text-primary font-weight-bold">{language.PROFILE_EDITED}</span>:""}
                </div>
                
                <div className="col-md-7 mb-4 d-md-flex justify-content-between align-items-end">
                    <div>
                        <div className="text-muted font-size-lg font-weight-bold" >{language.PROFILE_EDIT_NATURE_BUSSINESS}</div>
                        <div className="font-size-lg font-weight-bold" >{userinfo.nature_buss}</div>
                    </div>
                    {contactbookuserinfo.nature_buss !== userinfo.nature_buss?<span className="text-primary font-weight-bold">{language.PROFILE_EDITED}</span>:""}
                </div>
                <div className="col-md-7 mb-4 d-md-flex justify-content-between align-items-end">
                    <div>
                        <div className="text-muted font-size-lg font-weight-bold" >{language.PROFILE_EDIT_BUSSINESS_EST_DATE}</div>
                        <div className="font-size-lg font-weight-bold" >{userinfo.buss_esta_date?new Date(userinfo.buss_esta_date).toISOString().split("T")[0]:""}</div>
                    </div>
                    {contactbookuserinfo.buss_esta_date !== userinfo.buss_esta_date?<span className="text-primary font-weight-bold">{language.PROFILE_EDITED}</span>:""}
                </div>
                {userinfo?.region !== "Australia"?<div className="col-md-7 mb-4 d-md-flex justify-content-between align-items-end">
                    <div>
                        <div className="text-muted font-size-lg font-weight-bold" >{userinfo?.region === "India"?"GST NO":userinfo?.region === "Europe"?"VAT":language.PROFILE_TAX}</div>
                        <div className="font-size-lg font-weight-bold" >{userinfo.company_tax}</div>
                    </div>
                    {contactbookuserinfo.company_tax !== userinfo.company_tax?<span className="text-primary font-weight-bold">{language.PROFILE_EDITED}</span>:""}
                </div>:""}
                
                <div className="col-12 border-bottom d-flex justify-content-between pb-3 mb-5 mt-8">
                    <h4>{language.PROFILE_OWNER_DETAILS}</h4>
                    {/* <button className="btn btn-sm btn-secondary" onClick={() => setEdit(true)}>{language.PROFILE_EDIT}</button> */}
                </div>

                <div className="col-md-7 mb-4 d-md-flex justify-content-between align-items-end">
                   <div>
                        <div className="text-muted font-size-lg font-weight-bold" >{language.PROFILE_EDIT_NAME_DPP}</div>
                        <div className="font-size-lg font-weight-bold" >{userinfo.director_name}</div>
                   </div>
                    {contactbookuserinfo.director_name !== userinfo.director_name?<span className="text-primary font-weight-bold">{language.PROFILE_EDITED}</span>:""}
                </div>
                <div className="col-md-7 mb-4 d-md-flex justify-content-between align-items-end">
                    <div>
                        <div className="text-muted font-size-lg font-weight-bold" >{language.PROFILE_EDIT_PHOTO_ID}</div>
                        <div className="row">
                            <div className="col-md-12 d-md-flex">
                                <div className="font-size-lg font-weight-bold" >{userinfo.passport_id} </div>
                                {userinfo.passport_file ? 
                                    <OverlayTrigger
                                        placement="top"
                                        className="text-capitalize"
                                        overlay={<Tooltip id="tooltip">{userinfo.passport_file}</Tooltip>}
                                    >
                                        <a href={process.env.REACT_APP_ENV === "production"?`https://assets.diamondsoncall.com/assets/documents/${userinfo.passport_file}`:`${BASE_URL_OLD}/assets/documents/${userinfo.passport_file}`} target="_blank" rel="noreferrer" className="font-weight-bold ml-md-10">{language.PROFILE_EDIT_VIEW_IMAGE}</a>
                                    </OverlayTrigger>
                                : "" }
                            </div>
                        </div>
                    </div>
                    {contactbookuserinfo.passport_file !== userinfo.passport_file?<span className="text-primary font-weight-bold">{language.PROFILE_EDITED}</span>:""}
                </div>
                <div className="col-md-7 mb-4 d-md-flex justify-content-between align-items-end">
                    <div>
                        <div className="text-muted font-size-lg font-weight-bold" >{language.PROFILE_EDIT_CONTACT_DPP}</div>
                        <div className="font-size-lg font-weight-bold" >{userinfo.directory_contact}</div>
                    </div>
                    {contactbookuserinfo.directory_contact !== userinfo.directory_contact?<span className="text-primary font-weight-bold">{language.PROFILE_EDITED}</span>:""}
                </div>
                
            </div>
        </>
    );
}
